import React from "react"
import modStyl from './index.module.scss'

const TermsOfService = ()=> {
  return (
    <div className={modStyl.greeWrap}>
      <div className={modStyl.title}>科研数据小助手用户服务协议</div><br />
      <div className={modStyl.section}>欢迎您使用科研数据小助手的服务！</div>
      <div className={modStyl.section}>
          为使用科研数据小助手的服务，您应当阅读并遵守本《科研数据小助手用户服务协议》（以下简称“本协议”）。本协议是用户与科研数据小助手之间的法律协议，是用户注册科研数据小助手账号并使用科研数据小助手平台服务或非经注册程序直接使用科研数据小助手平台服务时的通用条款。请您务必审慎阅读、充分理解本协议各条款内容，特别是免除或者限制责任的条款、管辖与法律适用条款。限制、免责条款可能以黑体加粗或加下划线的形式提示您重点注意。如果您不同意本协议的约定，您应立即停止注册程序或停止使用科研数据小助手平台服务；如您继续访问和使用科研数据小助手平台服务，即视为您已确知并完全同意本协议各项约定。
      </div>
      <br />一、定义<br />
      <br />1.科研数据小助手平台，是惠每数科(北京)医疗科技有限公司旗下致力于做医疗健康资讯服务业务，科研数据小助手平台系专注于为用户提供调研、病例、视频科普、专家讲课、病例分享、病例点评等服务为一体的互联网医疗健康平台。
      <br />2.用户，以下亦称为“您”，系指注册或登录科研数据小助手平台使用科研数据小助手产品或服务的具有完全民事权利能力和行为能力的企业法人、社会团体、自然人或其他社会组织等。按用户是否经过注册程序分为注册用户和非注册用户，注册用户是指通过科研数据小助手平台完成全部注册程序后，使用科研数据小助手平台服务的用户。非注册用户是指未进行注册、直接登录科研数据小助手平台或通过其他科研数据小助手平台允许的方式进入科研数据小助手平台直接或间接地使用科研数据小助手平台服务或科研数据小助手网站资料的用户。
      <br />3.协议方，本协议中的协议方包括科研数据小助手平台运营方以及为科研数据小助手平台提供技术服务、咨询服务的关联方作为一方，统称“科研数据小助手”，您作为另一方。
      <br />
      <br />二、协议的效力<br />
      <br />1.在您按照注册页面提示填写信息、阅读并同意本协议并完成全部注册程序后或以其他科研数据小助手允许的方式实际使用科研数据小助手平台服务时，您即受本协议的约束。
      <br />2.本协议内容包括本协议正文，您在使用科研数据小助手某一特定服务或系统时，该服务可能会另有单独的协议、相关业务规则、公告、帮助、说明、通用条款等（以下统称为“规则”）。所有科研数据小助手已经发布的或将来可能发布的规则均为本协议不可分割的组成部分，与本协议具有同等法律效力。除另行明确声明外，任何科研数据小助手及其关联公司提供的服务（以下称为“科研数据小助手平台服务”）均受本协议约束。您承诺接受并遵守本协议的约定。如果您不同意本协议的约定，您应立即停止注册程序或停止使用科研数据小助手平台服务；如您继续访问和使用科研数据小助手平台服务，即视为您已确知并完全同意本协议各项内容。
      <br />
      <br />三、注册<br />
      <br />1.您确认，在您完成注册程序或以其他科研数据小助手允许的方式实际使用科研数据小助手平台服务时，您应当是具备完全民事行为能力的自然人、法人或其他组织。若您不具备前述主体资格，则您及您的家长或法定监护人（以下统称＂监护人”）应承担因此而导致的一切后果，且科研数据小助手有权注销您的账户，并向您及您的监护人索偿。
      <br />2.科研数据小助手非常重视对青少年个人信息搜集和使用的安全性的保护。任何未满18周岁的未成年人参加网上活动应事先取得其监护人可经查证的同意并遵守《全国青少年网络文明公约》。监护人应承担未成年人网络活动风险及保护未成年人相关网络隐私的首要责任。
      <br />3.在您签署本协议，完成注册程序时，科研数据小助手会向您提供唯一编号的科研数据小助手账户。您应对您的用户账户、登录密码、验证码的安全以及对通过您的账户实施的行为负责，除非有法律规定或行政司法机关的指令，且征得科研数据小助手的同意，否则您的用户账户不得以任何方式转让、借用、赠与或继承（与账户相关的财产权益除外），您的登录密码和验证码不得对任何第三方提供或泄露，否则，由此给您（或科研数据小助手、任何第三方）造成的一切损失，概由您自行承担（或者负责赔偿），科研数据小助手不承担任何责任。
      <br />4.如果发现任何人不当使用您的账户或有任何其他可能危及您的账户安全的情形时，您应当立即与科研数据小助手客服联系并通知科研数据小助手暂停或停止提供相关服务。您理解科研数据小助手对您的请求采取行动需要合理时间，科研数据小助手对在采取行动前已经产生的后果（包括但不限于您的任何损失）不承担任何责任。
      <br />
      <br />四、科研数据小助手平台服务规范<br />
      <br />1.通过科研数据小助手平台，您可以按照科研数据小助手的规则发布信息。但所发布之信息不得含有如下内容：
      <br />1)反对宪法所确定的基本原则，煽动抗拒、破坏宪法和法律、行政法规实施的。
      <br />2)煽动危害国家安全、泄露国家秘密、颠覆国家政权，推翻社会主义制度的。
      <br />3)煽动分裂国家、破坏国家统一、损害国家荣誉和民族利益的。
      <br />4)煽动民族仇恨、民族歧视、破坏民族团结的。
      <br />5)捏造或者歪曲事实，散布谣言，扰乱社会秩序的。
      <br />6)进行政治宣传或破坏国家宗教政策、宣扬封建迷信、淫秽、色情、赌博、暴力、凶杀、恐怖、教唆犯罪的。
      <br />7)公然侮辱他人或者捏造事实诽谤他人的，或者进行其他恶意攻击的。
      <br />8)损害国家机关信誉的。
      <br />9)其他违反宪法和法律法规规定的。
      <br />2.在接受科研数据小助手平台服务的过程中，您不得从事下列行为：
      <br />1)发表、传送、传播、储存侵害他人知识产权、商业秘密权等合法权利的内容，包括但不限于病毒、木马、定时炸弹等可能对科研数据小助手系统造成伤害或影响其稳定性的内容制造虚假身份以误导、欺骗他人。
      <br />2)传送或散布以其他方式实现传送的含有受到知识产权法律保护的图像、相片、软件或其他资料的文件，作为举例（但不限于此）：包括版权或商标（或隐私权或公开权），除非用户拥有或控制着相应的权利或已得到所有必要的认可。
      <br />3)使用任何包含有通过侵犯商标、版权、专利、商业机密或任何一方的其他专有权利的方式利用本平台获得的图像或相片的资料或信息。
      <br />4)进行危害计算机网络安全的行为，包括但不限于：使用未经许可的数据或进入未经许可的服务器/账号；未经允许进入公众计算机网络或者他人计算机系统并删除、修改、增加存储信息；未经许可，企图探查、扫描、测试本平台系统或网络的弱点或其它实施破坏网络安全的行为；企图干涉、破坏本平台系统或网站的正常运行，故意传播恶意程序或病毒以及其他破坏干扰正常网络信息服务的行为；伪造TCP/IP数据包名称或部分名称。
      <br />5)修改或伪造软件作品运行中的指令、数据、数据包，增加、删减、变动软件的功能或运行效果，不得将用于上述用途的软件通过信息网络向公众传播或者运营。
      <br />6)在未经科研数据小助手书面明确授权前提下，出售、出租、出借、散布、转移或转授权软件和服务或相关的链接或从使用软件和服务或软件和服务的条款中获利，无论以上使用是否为直接经济或金钱收益。
      <br />3.您了解并同意，科研数据小助手有权应政府部门（包括司法及行政部门）的要求，向其提供您在科研数据小助手平台填写的相关必要信息。
      <br />4.您了解并同意，为了向您提供有效的服务，科研数据小助手平台可能使用您的终端设备的带宽资源，使用过程中可能产生数据流量的费用，您需自行向运营商了解相关资费信息，并自行承担相关费用。
      <br />5.您了解并同意，科研数据小助手平台提供的服务的形式和本质可不经事先通知您而不时变换。相关服务更新或部分服务内容更新后，在可能的情况下，科研数据小助手将以包括但不限于系统提示、公告、站内信等方式提示用户，您有权选择接受更新版本或服务，如您不接受，部分功能将受到限制或不能继续使用。
      <br />6.您了解并同意，您通过使用服务而下载或以其他方式获得的任何材料由您自行作出并承担风险，您将独自对由于下载任何该等材料而导致对电脑系统或其他装置的损害或数据的丢失负责。
      <br />7.您使用科研数据小助手平台服务，即视为您理解并同意以下内容：
      <br />1)本平台仅为用户提供发布和上传视频、病例、点评，参加调研、专家课程等；
      <br />2)对于科研数据小助手平台提供的服务，您享有自主选择的权利，但您做出的任何选择及/或决定，均系您依据自身的独立判断做出。本平台不会干涉用户的任何选择及/或决定，亦不对用户的任何选择及/或决定所造成的风险及损害结果承担任何责任。
      <br />3)您不得以任何理由支付回扣或奖励，或者其它付款或送礼给患者及/或潜在受试者作为参加项目的利益交换。
      <br />4)其他因您不当使用本平台服务而导致的任何意外，及其所造成的一切后果均由您本人自行承担，科研数据小助手不承担任何责任。
      <br />8.在科研数据小助手平台上使用科研数据小助手提供的服务过程中，您承诺遵守以下约定：
      <br />1)在使用科研数据小助手平台服务过程中实施的所有行为均遵守国家法律、法规等规范文件及科研数据小助手平台各项规则的规定和要求，不违背社会公共利益或公共道德，不损害他人的合法权益，不违反本协议及相关规则。您如果违反前述承诺，产生任何法律后果的，您应以自己的名义独立承担所有的法律责任，并确保科研数据小助手免于因此产生任何损失或增加费用。
      <br />2)不发布国家禁止发布的信息（除非取得合法且足够的许可），不发布涉嫌侵犯他人知识产权或其它合法权益的信息，不发布违背社会公共利益或公共道德、公序良俗的信息，不发布其它涉嫌违法或违反本协议及各类规则的信息。
      <br />3)不对科研数据小助手平台上的任何数据作商业性利用，包括但不限于在未经科研数据小助手事先书面同意的情况下，以复制、传播等任何方式使用科研数据小助手平台站上展示的资料。
      <br />4)不使用任何装置、软件或例行程序干预或试图干预科研数据小助手平台的正常运作或正在科研数据小助手平台上进行的任何活动。您不得采取任何将导致不合理的庞大数据负载加诸科研数据小助手平台网络设备的行动。
      <br />9.您确认并承诺：
      <br />1)您所在的医疗机构、单位或其他组织未对您使用科研数据小助手平台作出任何禁止性规定。
      <br />2)您所填写的有关患者的相关信息（包括一般个人信息、敏感个人信息），均已按照《个人信息保护法》及其他相关法律、法规的要求向患者履行告知义务，并已按照法律规定获得患者的明示、单独同意。
      <br />10.您了解并同意：
      <br />1)您违反上述承诺时，科研数据小助手有权依据本协议的约定，做出相应处理或终止向您提供服务，且无须征得您的同意或提前通知于您。
      <br />2)根据相关法令的指定或者科研数据小助手平台服务规则的判断，您的行为涉嫌违反法律法规的规定或违反本协议和／或规则的条款的，科研数据小助手有权采取相应措施，包括但不限于删除侵权信息、停止提供服务等。
      <br />3)对于您在科研数据小助手平台上实施的行为，包括您未在科研数据小助手平台上实施但已经对科研数据小助手平台及其用户产生影响的行为，科研数据小助手有权单方认定您行为的性质及是否构成对本协议和／或规则的违反，并据此采取相应的处理措施。您应自行保存与您行为有关的全部证据，并应对无法提供充要证据承担不利后果。
      <br />4)对于您涉嫌违反承诺的行为对任意第三方造成损害的，您均应当以自己的名义独立承担所有的法律责任，并应确保科研数据小助手免于承担因此产生的损失或增加的费用。
      <br />5)如您涉嫌违反有关法律或者本协议之规定，使科研数据小助手遭受任何损失，或受到任何第三方的索赔，或受到任何行政管理部门的处罚，您应当赔偿科研数据小助手因此造成的损失及（或）发生的费用，包括合理的维权费用（包括但不限于诉讼费、仲裁费、律师费、公证费、调查取证费、保全费、交通费等）。
      <br />
      <br />五、数据保护条款<br />
      <br />1.科研数据小助手平台运营方是本网站上呈现的所有信息内容的所有权及知识产权权利人，前述信息内容包括但不限于程序代码、界面设计、版面框架、数据资料、账号、文字、图片、图形、图表、音频、视频等。同时，科研数据小助手平台运营方对科研数据小助手服务开发和运营等过程中产生的所有数据和信息等享有全部权利。以上权利归属除按照法律法规规定或协议约束应由相关权利方享有权利的内容除外。
      <br />2.未经科研数据小助手运营方书面许可，您不得自行或授权、允许、协助任何第三人将本网站中信息直接或间接用于其他任何商业目的或用途。
      <br />3.科研数据小助手平台运营方有权但无义务对您发布的内容进行审核，有权根据相关证据结合《中华人民共和国民法典》、《信息网络传播权保护条例》等法律法规对侵权信息进行处理。
      <br />4.您在科研数据小助手平台上传或发表的内容，您应保证自身为著作权人或已取得合法授权，并且该内容不会侵犯任何第三方的合法权益。如果第三方提出关于著作权的异议，科研数据小助手有权根据实际情况删除相关的内容，且有权追究您的法律责任。给科研数据小助手或任何第三方造成损失的，用户应负责全额赔偿。
      <br />5.您认知并同意，科研数据小助手对服务拥有一切法定权利、所有权和利益，包括存在于服务中的任何知识产权（无论该等权利是否已经登记，也不论该等权利在世界的何等地方存在）。您进一步认知，服务可能包括科研数据小助手指定为保密的信息，未经科研数据小助手事先书面同意，您不得披露该等信息。
      <br />6.除非您与科研数据小助手另有书面协议，否则本协议中的任何规定均未给予您使用科研数据小助手任何商号、商标、服务标记、标识、域名及其他显著品牌特征的权利。
      <br />7.您同意，您不得删除、掩藏或改动服务所附的或包含的任何专有权利声明（包括著作权和商标声明）。
      <br />8.您认知并同意，前述知识产权条款不因您关闭平台账户或停止使用平台服务而失效。
      <br />
      <br />六、报酬与缴税<br />
      <br />1.您确认对科研数据小助手产品及服务的使用，不视为您与平台建立任何劳动关系，平台亦无任何义务向您发放任何工资、薪金、奖金、津贴，缴纳社会保险与公积金等。
      <br />2.您所进行的上传患者病历信息、患教会视频、专家讲课视频、完成调研问卷等行为，平台将视具体情况，根据您在平台中留下的账户信息，向您支付符合市场公允价的服务费。
      <br />3.您确认并同意，就前述科研数据小助手平台支付的服务费用，平台将依照《个人所得税法》及其他相关法律、法规代为扣除相应税负。
      <br />
      <br />七、本协议的终止<br />
      <br />1.如果您希望终止使用科研数据小助手产品及服务的，您可以科研数据小助手平台规定的方式注销账号及相关使用信息。
      <br />2.发生下列情况时科研数据小助手平台可单方终止与您的服务关系及相关协议约定：
      <br />1)您违反了本协议的任何规定（或您的行为方式明确显示您不打算或不能遵守本协议规定）；
      <br />2)法律要求科研数据小助手这样做（例如：向您提供服务不合法或变得不合法）
      <br />3)科研数据小助手及/或与科研数据小助手共同向您提供服务的合作伙伴已终止与科研数据小助手的关系或停止提供服务；
      <br />4)科研数据小助手认为须立刻终止本协议的其他情形。
      <br />3.本协议终止时，因您违反本协议约定而须承担的所有责任不受该终止的影响。
      <br />
      <br />八、责任承担<br />
      <br />1.在遵守本协议全部规定的前提下，您明示理解并同意，科研数据小助手不就以下事项对您承担责任：
      <br />1)您无论由于何种原因和在任何责任理论项下发生的任何直接、间接、附带、特殊、后果性或惩罚性的损害。这应包括但不限于任何利润损失（无论是直接还是间接发生）、任何商誉或业务声誉损失、任何数据丢失、替代物品或服务的购买费用或其他无形损失；
      <br />2)前文所述您可能产生的任何损失或损害，包括但不限于由下列原因导致的损失或损害：
      <br />i.科研数据小助手对服务可能做出的变更，或永久或暂时停止提供服务（或服务中的任何功能）；
      <br />ii.对通过您使用服务而维持或传输的任何内容及其他通信数据的删除、毁坏；
      <br />iii.您未向科研数据小助手提供准确的个人信息；
      <br />iv.您未对您的帐户资料或密码保持安全及保密。
      <br />2.科研数据小助手不对您发表的回答或评论的正确性进行保证。
      <br />3.用户在科研数据小助手发表的内容仅表明其个人的立场和观点，并不代表科研数据小助手的立场或观点。用户需自行对所发表内容负责，因所发表内容引发的一切纠纷，由用户自行承担全部法律及连带责任。科研数据小助手不承担任何法律及连带责任。
      <br />4.科研数据小助手不保证所提供的服务一定能满足用户的全部要求，也不保证服务不会中断，对服务的及时性、安全性、准确性也都不作保证。
      <br />5.对于因不可抗力或科研数据小助手不能控制的原因造成的任何问题，科研数据小助手不承担任何责任，但将尽力减少因此而给用户造成的损失和影响。
      <br />6.用户基于科研数据小助手平台成功招募患者及/或受试者后，患者及/或受试者在用户项目过程中所作出的全部行为，均由患者、受试者以及用户自行承担，科研数据小助手不对患者及/或受试者的任何行为承担任何责任。
      <br />
      <br />九、本协议的变更<br />
      <br />1.科研数据小助手可不时对通用条款或附加条款作出变更，届时协议更新会通过系统提示、信息推送和／或您在我方平台留下的联系方式通知提醒您注意。
      <br />2.您理解并同意，如果您在通用条款或附加条款变更日期之后使用服务，则科研数据小助手将把您的使用视为接受更新后的通用条款或附加条款。
      <br />3.您可以通过微信小程序“意见反馈”功能查看用户协议的历史文本。
      <br />
      <br />十、一般法律条款<br />
      <br />1.本协议未规定的内容请以国家有关法律法规为准，若本协议与国家法律法规规定发生冲突时，以国家法律法规为准。
      <br />2.本协议及本协议条款项下您与科研数据小助手的关系，受中国法律管辖，但排除其冲突法规定。
      <br />3.您与科研数据小助手均同意接受上海市徐汇区人民法院的管辖，以解决任何由本协议引起的法律事项。
      <br />4.本协议中的条款，请您着重阅读。您点击“同意”按钮即视为您完全接受本协议，在点击之前请您再次确认已知悉并完全理解本协议的全部内容。
      <br />
    </div>
  )
}

export default TermsOfService